import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint, SignInPageProps } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

const microsoftProvider = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft',
  message: 'Sign in with your Hone account',
  apiRef: microsoftAuthApiRef,
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () =>
      function HoneSignInPage(props: SignInPageProps) {
        return <SignInPage {...props} auto provider={microsoftProvider} />;
      },
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
